import type { ComponentPropsWithRef } from 'react';
import { cn } from '@/shared/lib/utils';

/**
 * Table行コンポーネント
 */
type TableRowProps = ComponentPropsWithRef<'tr'>;

export const TableRow = ({ className, ref, ...props }: TableRowProps) => (
  <tr
    ref={ref}
    className={cn(
      'border-border-strength1 border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted',
      'hover:bg-stone-50',
      className,
    )}
    {...props}
  />
);
